function getParent(el, name) {
  let p = el;
  let classes = [...p.classList];
  while (classes.indexOf(name) === -1) {
    p = p.parentElement;
    classes = [...p.classList];
  }
  return p;
}

export default function (el, top = 90) {
  if (!el) {
    return;
  }
  const elErr = el.querySelector('.ul-form-item--error');
  if (!elErr) {
    return;
  }
  const parent = getParent(elErr, 'ul-card')
    || getParent(elErr, 'ul-form');
  if (!parent) {
    return;
  }
  window.scrollTo({
    top: window.pageYOffset + parent.getBoundingClientRect().top - top,
  });
  const input = elErr.querySelector('input');
  if (input) {
    input.focus();
  }
}
